import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useSearchDrugQuote = () => {
    const { mutate: searchDrugQuote, isLoading } = useMutation(
        async (params) => {
            const response = await SrxApi.get('/drugsearch/quote', { params });
            return response?.data;
        },
        {
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    'Failed to search drug quotes';
                toast.error(errorMessage);
            },
        }
    );

    return {
        searchDrugQuote,
        isSearchDrugQuoteLoading: isLoading,
    };
};

export default useSearchDrugQuote;
